/* eslint-disable no-restricted-syntax -- this line was auto generated, hence fix the issue timely */
import useClientCachedURL from "../hooks/useClientCachedURL";
import useReloadIfSearchStoreMissing, { isSearchStoreInitial } from "../hooks/useReloadIfSearchStoreMissing";
import useStoreMetaOfferWhenLanding from "../hooks/useStoreLandingMetaOffer";
import React, { Profiler, useCallback, useEffect, useMemo, useState } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import {
  metaPreOptedAncillariesFromFlightDetailsScreenQueryToApiQuery,
  metaPreOptedAncillariesFromFlightToStore
} from "../utils/preOptedAncillaries";
import { flightsSessionStore } from "@flights/web-api-utils-universal";
import { trackMetaChannelStagesV2, trackMetaLandingsCustomGoalsV2 } from "../utils/experiments/track-meta-landings-v2";
import { UIFlightData, UIServiceError } from "@flights/types";
import { CheckoutPaxDesktop } from "../app/routes";
import { FlightDetailsInnerDesktop } from "../components/elements/FlightDetailsInner";
import { POSMisMatchDesktop } from "../components/elements/POSMisMatch";
import {
  FLIGHT_DETAILS_RETRYABLE_ERROR_CODES,
  FLIGHT_DETAILS_MODAL_CLOSE_ERROR_CODES,
  LANDING_OFFER_FROM_META_KEY,
  PRICE_ACCURACY_TAG_FIRED_OFFER,
  SEATMAP_EXTRA_TYPE
} from "../constants";
import { useClientFetch } from "../hooks/useClientFetch";
import useClientMetrics from "../hooks/useClientMetrics";
import useCreateUrl from "../hooks/useCreateUrl";
import useEventTracking from "../hooks/useEventTracking";
import useFlightDetailsFromSearchResults from "../hooks/useFlightDetailsFromSearchResults";
import useGlobalContext from "../hooks/useGlobalContext";
import { useGoogleFlightsPriceAccuracyTag, useSkyScannerPriceAccuracyTag } from "../hooks/useGTMPriceAccuracyTags";
import useTrackPageLoad from "../hooks/useTrackPageLoad";
import { actions as extraProductActions } from "../ancillaries/store/extraProducts/actions";
import { actions as flightDetailsActions } from "../store/flightDetails/actions";
// eslint-disable-next-line import/no-deprecated -- this line was auto generated, hence fix the issue timely
import { useActions, useStore } from "../store";
import { isOfGoogleFlightsOrigin, isOfMetaOrigin, isOfSkyScannerOrigin } from "../utils/marketing-url-params";
import { getMarketingTrackingVariable } from "@flights/web-api-utils-universal";
import { PageHeader } from "./FlightDetails";
import useTrackFlightDetailsPriceChangeGoal from "../hooks/useTrackFlightDetailsPriceChangeGoal";
import useReportPriceDiscrepancy from "../hooks/useReportPriceDiscrepancy";
import useTrackFlightsWebUseOfferPos from "../hooks/useTrackFlightsWebUseOfferPosExp";
import useRetryFlightDetailsApi from "../hooks/useRetryFlightDetailsApi";
import useFlightOfferInSearchResults from "../hooks/useFlightOfferInSearchResults";
import useLogFORAPErrors from "../hooks/useLogFORAPErrors";
import { trackAppsShareFlightWebAAStages } from "../utils/experiments/meta/flights_ios_share_flight_link";
import useReportBaggageQuality from "../hooks/useReportBaggageInfoDiscrepancy";
import useTrackFlightDetailsBrandedFaresGoals from "../hooks/useTrackFlightDetailsBrandedFaresGoals";
import NoSSR from "../app/NoSSR";
import flights_web_apex_ancillaries_aa from "../utils/experiments/apex/flights_web_apex_ancillaries_aa";
import useBrandedFares from "../branded-fares/hooks/useBrandedFares";
import { useSearchResultOffer, usePrefetchedBrandedFaresOffer } from "../hooks/useSearchResults";
import useAlternativeFaresParams from "../hooks/useAlternativeFaresParams";
import useEvents from "../hooks/useEvents";
import { carrierUtils, pricingUtils } from "@flights/web-api-utils-universal";
import useKayakS2SParams from "../hooks/useKayakS2SParams";
import useGetSearchResultsBound from "../hooks/useGetSearchResultsBound";
import flights_web_condensed_extras_fd_ddot from "../utils/experiments/funnel/flights_web_condensed_extras_fd_ddot";
import { goal } from "@flights/et-universal";
import { useSplitBoundsCondition } from "../utils/experiments/funnel/flights_split_bounds_us";
import useCaParamsCleanup from "../hooks/useCaParamsCleanup";
import { trackMetaExperimentStage } from "../utils/meta-et-tracking";
import flights_apex_web_insurance_dynamic_link from "../utils/experiments/apex/flights_apex_web_insurance_dynamic_link";
import flights_apex_web_persist_ancillaries_improvements from "../utils/experiments/apex/flights_apex_web_persist_ancillaries_improvements";
import flights_web_remove_baggage_weight_size_fd from "../utils/experiments/funnel/flights_web_remove_baggage_weight_size_fd";

const debug = require("debug")("screen:FlightDetails");

const _FlightDetailsDesktop = () => {
  const params = useParams<{
    id: string;
    airports: string;
    /* start - flights_split_bounds_us */
    outboundToken: string;
    /* end - flights_split_bounds_us */
  }>();
  /* eslint-disable import/no-deprecated */
  const store = useStore();
  const actions = useActions(flightDetailsActions);
  const extrasActions = useActions(extraProductActions);
  /* eslint-enable import/no-deprecated */
  const history = useHistory();
  const { createUrl } = useCreateUrl();
  const { requestId, features } = useGlobalContext();
  const { trackRenderTime } = useClientMetrics();
  const { cacheLastSuccessfulSearchUrl } = useClientCachedURL();
  const trackContextEventV2 = useTrackPageLoad("flight_details");
  const trackV2 = useEventTracking("flight_details", requestId);
  const googleFlightsPriceAccuracyTag = useGoogleFlightsPriceAccuracyTag();
  const skyScannerPriceAccuracyTag = useSkyScannerPriceAccuracyTag();
  const { grumble } = useEvents();
  const cleanupCaParams = useCaParamsCleanup();

  useStoreMetaOfferWhenLanding(params?.id);

  const landingMetaOffer = flightsSessionStore.get(LANDING_OFFER_FROM_META_KEY);

  const isMetaUser = isOfMetaOrigin();
  const isGoogleFlightsUser = isOfGoogleFlightsOrigin();
  const isSkyscannerUser = isOfSkyScannerOrigin();
  const enableGfsPosMismatch = features["FLIGHTS_META_ENABLE_GFS_FOR_POS_MISMATCH"] && isGoogleFlightsUser;
  const flightsWebUseOfferPos = useTrackFlightsWebUseOfferPos();
  const { setFlightDetailsApiForRetry } = useRetryFlightDetailsApi();
  const { getTotalPrice } = useFlightOfferInSearchResults();

  useReportBaggageQuality(params.id);

  useEffect(() => {
    trackContextEventV2();
    goal("flights_flight_details_page_view");
    cacheLastSuccessfulSearchUrl(params?.airports);
    trackMetaChannelStagesV2("desktop");
    flights_web_apex_ancillaries_aa.stages.flight_details();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const { setAlternativeFaresParams, getAlternativeFaresParams } = useAlternativeFaresParams();

  useEffect(() => {
    const params = getAlternativeFaresParams();
    if (isMetaUser && !params?.searchedAt) {
      setAlternativeFaresParams("searchedAt", new Date().getTime());
    }
  }, [getAlternativeFaresParams, isMetaUser, setAlternativeFaresParams]);

  let flight = useFlightDetailsFromSearchResults(params?.id);

  /* start - flights_web_condensed_extras_fd_ddot */
  flights_web_condensed_extras_fd_ddot.trackWithDefaultStage();
  /* end - flights_web_condensed_extras_fd_ddot */

  useEffect(() => {
    if (flight) {
      const queryParams = new URLSearchParams(location.search);
      trackAppsShareFlightWebAAStages(false, queryParams.get("label") || undefined);
    }
  }, [flight, isMetaUser, store.flightDetails.fetchStatus]);

  useLogFORAPErrors(params.id);
  // flights_web_search_cache_ttl_30_mins
  useTrackFlightDetailsPriceChangeGoal();
  useTrackFlightDetailsBrandedFaresGoals();

  debug("searchResults.flights[x]", flight);
  const urlParams = new URLSearchParams(useLocation().search);

  const searchParams = metaPreOptedAncillariesFromFlightDetailsScreenQueryToApiQuery(urlParams);

  if (
    process.env.BUILD_TARGET === "client" &&
    !flights_apex_web_persist_ancillaries_improvements.trackWithDefaultStage()
  ) {
    searchParams.set("excludedAncillaries", SEATMAP_EXTRA_TYPE);
  }

  const { flight: fetchedFlight, fetchStatus } = store.flightDetails;

  useKayakS2SParams(fetchStatus, flight, landingMetaOffer, searchParams, params);

  const flightOffer = useSearchResultOffer(params?.id);
  const brandedFareOffer = useBrandedFares(params?.id).brandedFareOffers?.length;
  const prefetchedbrandedFareOffer = usePrefetchedBrandedFaresOffer(params?.id);

  const hasPrefetchedBrandedFareOffers =
    flightOffer && !flightOffer.requestableBrandedFares && !prefetchedbrandedFareOffer && brandedFareOffer;

  if (hasPrefetchedBrandedFareOffers || prefetchedbrandedFareOffer) {
    searchParams.set("hasPrefetchedBrandedFareOffers", "true");
  }

  const hasFlightInStore = useMemo(
    () => store.searchResults.flights.find((flight) => flight.token === params.id),
    [store.searchResults, params.id]
  );

  const requestableBrandedFares = hasFlightInStore?.requestableBrandedFares;
  const shouldSkipBrandedFares = hasFlightInStore && !requestableBrandedFares;

  if (shouldSkipBrandedFares) {
    searchParams.set("skipBrandedFares", "1");
  }

  if (flightsWebUseOfferPos.isVariant) {
    const salesCountry = getMarketingTrackingVariable("salesCountry");
    if (salesCountry) {
      searchParams.set("salesCountry", salesCountry);
      setAlternativeFaresParams("salesCountry", salesCountry);
    }
  }

  const { units, nanos, currencyCode } = getTotalPrice(params?.id, urlParams.get("baseOfferToken") || "") || {};
  if (units) {
    const formattedPrice = `${units}-${nanos}-${currencyCode}`;
    setAlternativeFaresParams("priceInSearch", formattedPrice);
  } else {
    setAlternativeFaresParams("priceInSearch", "");
  }

  const brandedFareIndex = urlParams.get("brandedFareIndex");
  const caSource = urlParams.get("ca_source");
  const caPrice = urlParams.get("ca_price");
  const source = urlParams.get("source");

  if (caSource) {
    searchParams.set("ca_source", caSource);
  }

  if (caPrice) {
    searchParams.set("ca_price", caPrice);
  }

  if (brandedFareIndex) {
    searchParams.set("brandedFareIndex", brandedFareIndex);
  }

  if (source) {
    searchParams.set("source", source);
  }

  const url = `/api/flight/${params?.id}?${searchParams.toString()}`;

  const [controller] = useState(() => new AbortController());

  useClientFetch(url, {
    signal: controller.signal,
    condition: () => {
      return !isSearchStoreInitial(store.search);
    },
    fetch: () => {
      actions.fetch();
    },
    success: (data: UIFlightData) => {
      onFetchSuccess(data);
    },
    error: (error: UIServiceError) => {
      grumble("Failed to fetch flight details on desktop", error);

      if (error.code === "CANCELLED_DUE_TO_UNMOUTING") {
        actions.fetchReset();
        return;
      }

      if (FLIGHT_DETAILS_MODAL_CLOSE_ERROR_CODES.includes(error.code)) {
        onCloseWithTracking({ forceReload: false });
        return;
      }

      if (isGoogleFlightsUser) {
        trackV2("google_flights_landing_shallow", {
          isShallow: true,
          airlineIATA: []
        });

        googleFlightsPriceAccuracyTag(0, "");
      }

      if (flight) {
        setFlightDetailsApiForRetry(error);
      }
      actions.fetchError(error);
    }
  });

  const onFetchSuccess = (data: UIFlightData) => {
    actions.fetchSuccess(data);
    data.ancillaries && metaPreOptedAncillariesFromFlightToStore(data.ancillaries, extrasActions);

    if (data.ancillaries?.travelInsurance) {
      flights_apex_web_insurance_dynamic_link.stages.main();
    }

    if (params?.id === landingMetaOffer && isGoogleFlightsUser) {
      trackV2("google_flights_landing_shallow", {
        isShallow: false,
        airlineIATA: carrierUtils.uniqueCarriersFromSegments(data.segments)
      });
      googleFlightsPriceAccuracyTag(
        pricingUtils.priceToNumber(data.priceBreakdown.total),
        data.priceBreakdown.total.currencyCode
      );
    }

    if (
      params?.id === landingMetaOffer &&
      flightsSessionStore.get(PRICE_ACCURACY_TAG_FIRED_OFFER) !== params?.id &&
      isSkyscannerUser
    ) {
      skyScannerPriceAccuracyTag(
        pricingUtils.priceToNumber(data.priceBreakdown.total),
        data.priceBreakdown.total.currencyCode
      );
      flightsSessionStore.set(PRICE_ACCURACY_TAG_FIRED_OFFER, params?.id);
    }

    const hasBrandedFares = data?.brandedFareOffers && data.brandedFareOffers.length > 0;

    if (shouldSkipBrandedFares && hasBrandedFares) {
      grumble("branded_fares_available_when_flag_false", {
        token: data.token,
        pointOfSale: data.pointOfSale,
        requestableBrandedFares: requestableBrandedFares,
        numOfBrandedFares: data?.brandedFareOffers && data.brandedFareOffers.length
      });
    }
  };

  useEffect(() => {
    return () => {
      cleanupCaParams();
    };
  }, [cleanupCaParams]);

  type CloseParams = {
    forceReload: boolean | undefined;
  };

  const bound = useGetSearchResultsBound();
  const { isSplitBounds: shouldShowSplitBounds } = useSplitBoundsCondition();

  const backToSearch = useCallback(
    (p?: CloseParams) => {
      actions.fetch(); //reset the current flight in store
      const urlParams = new URLSearchParams(location.search);
      urlParams.delete("selectedProducts");
      urlParams.delete("flexibleTicket");
      urlParams.delete("cancelForAnyReason");
      urlParams.delete("brandedFareIndex");

      let url = `/flights/${params?.airports}?${urlParams.toString()}`;

      /* start - flights_split_bounds_us */
      if (shouldShowSplitBounds) {
        if (bound === "outbound") {
          url = `flights/${params?.airports}/outbound/?${urlParams.toString()}`;
        }
        if (bound === "inbound") {
          url = `flights/${params?.airports}/inbound/${params?.outboundToken}/?${urlParams.toString()}`;
        }
      }
      /* end - flights_split_bounds_us */

      history.push(createUrl(url), { forceRefetch: p?.forceReload });
    },
    [actions, params?.airports, params?.outboundToken, shouldShowSplitBounds, history, createUrl, bound]
  );

  const onCloseWithTracking = (p?: CloseParams) => {
    trackMetaLandingsCustomGoalsV2(1, "desktop"); // track meta landing custom goal for users leaving FD and moving to SR on desktop
    trackMetaExperimentStage("flights_web_cat_pinning_meta_offer_on_sr_www", 1);
    flights_web_remove_baggage_weight_size_fd.goals.close_fd();
    backToSearch({ forceReload: p?.forceReload });
  };

  const handleErrorClose = () => {
    const errorDoesNotNeedReload = FLIGHT_DETAILS_RETRYABLE_ERROR_CODES.includes(
      (store.flightDetails.error as UIServiceError)?.code || ""
    );

    onCloseWithTracking({ forceReload: !errorDoesNotNeedReload });
  };

  useEffect(() => {
    /*eslint-disable-next-line flights/no-unassigned-todo-comments*/
    /* TODO(asamilyak): we probably should replace it with `CheckoutStartDesktop.preload()` */
    CheckoutPaxDesktop.preload();
  }, []);

  useReportPriceDiscrepancy(params.id);

  if (fetchStatus === "success" && fetchedFlight) {
    debug("FlightDetails fetched", fetchedFlight);
    flight = fetchedFlight;
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  if (useReloadIfSearchStoreMissing(store.search)) {
    return null;
  }

  const showPOSMismatch = flight && flight.posMismatch?.isPOSMismatch && !enableGfsPosMismatch;

  return (
    <Profiler id="screen" onRender={trackRenderTime}>
      <NoSSR>
        {flight && <PageHeader segments={flight.segments} />}
        {fetchStatus === "success" && showPOSMismatch && flight?.posMismatch?.isPOSMismatch && (
          <POSMisMatchDesktop goToSearch={backToSearch} POSMismatch={flight.posMismatch} />
        )}
        {(fetchStatus === "loading" || fetchStatus == "failed" || (flight && !showPOSMismatch)) && (
          <FlightDetailsInnerDesktop
            flightToken={params?.id}
            flight={flight}
            fetchStatus={fetchStatus}
            onClose={onCloseWithTracking}
            onErrorClose={handleErrorClose}
            hasPrefetchedBrandedFareOffers={!!(hasPrefetchedBrandedFareOffers || prefetchedbrandedFareOffer)}
          />
        )}
      </NoSSR>
    </Profiler>
  );
};

const FlightDetailsDesktop = React.memo(_FlightDetailsDesktop);

export default FlightDetailsDesktop;
